import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  title: 'Guía Esencial para Empezar a Tejer',
  desc: 'Aprendé desde cero evitando errores y frustraciones comunes.',
  price: '$17.990',
  image: 'https://cdn.magicpatterns.com/uploads/dTESMxd93xxfFebSy2aTCt/guia_tejer_comprimida_blanco.webp'
}, {
  title: 'Moda Tejida para Mascotas',
  desc: 'Patrones adorables para abrigar a tus amigos de cuatro patas con estilo.',
  price: '$12.990',
  image: 'https://cdn.magicpatterns.com/uploads/4ZJdssnGBCi4HeLjutB6Jn/moda_tejida_mascotas_blanco_comprimido.webp'
}, {
  title: 'Bolsos Tejidos Paso a Paso',
  desc: 'Crea accesorios únicos y funcionales para lucir o vender.',
  price: '$14.990',
  image: 'https://cdn.magicpatterns.com/uploads/uDksXELxj63ff9WLdGCPDj/bolsos_tejidos_blanco_comprimido.webp'
}, {
  title: 'Decoración en Macramé',
  desc: 'Aprende los nudos básicos y transformá cualquier espacio.',
  price: '$11.990',
  image: 'https://cdn.magicpatterns.com/uploads/3r7VuUGwdoUmF6sv6RcXzM/ChatGPT_Image_5_jun_2026,_00_13_08.webp'
}, {
  title: 'Tricotín Fácil y Creativo',
  desc: 'Ideas y proyectos originales para aprovechar esta técnica divertida.',
  price: '$8.990',
  image: 'https://cdn.magicpatterns.com/uploads/br94aK9pz3ftCCwtceM9kR/tricotin_blanco_comprimido.webp'
}, {
  title: 'Kit de Materiales para Tricotín',
  desc: 'La guía definitiva de herramientas y lanas recomendadas.',
  price: '$5.990',
  image: 'https://cdn.magicpatterns.com/uploads/kGjtERNfwZXtecY16VaDbs/kit_materiales_tricotin_blanco_comprimido.webp'
}, {
  title: 'Guía de Proveedores en Argentina',
  desc: 'Dónde comprar los mejores hilados al mejor precio.',
  price: '$15.990',
  image: 'https://cdn.magicpatterns.com/uploads/37odH7UxmUr2Tj5zU2rpPM/proveedores_argentina_blanco_comprimido.webp'
}];
export function Bonuses() {
  return <section className="py-14 px-6 bg-gradient-to-b from-white to-cream/50" data-id="element-26">
      <div className="max-w-4xl mx-auto" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-28">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/20 text-gold-dark mb-4" data-id="element-29">
            <Gift className="w-8 h-8" data-id="element-30" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-dark mb-2" data-id="element-31">
            ADEMÁS HOY TE LLEVÁS ESTOS{' '}
            <span className="italic text-rose-deep font-normal" data-id="element-32">
              REGALOS EXCLUSIVOS
            </span>
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-33">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="flex flex-row items-center bg-white rounded-2xl overflow-hidden shadow-soft border border-rose-light/20" data-id="element-34">
              {/* Ebook Cover Left Side */}
              <div className="flex-shrink-0 w-28 sm:w-44 bg-rose-light/20 p-3 sm:p-6 flex items-center justify-center border-r border-rose-light/20 self-stretch" data-id="element-35">
                <img src={bonus.image} alt={`Portada del ebook ${bonus.title}`} className="w-full h-auto object-contain drop-shadow-xl" loading="lazy" decoding="async" data-id="element-36" />
              </div>

              {/* Content Right Side */}
              <div className="flex-1 p-4 sm:p-8 flex flex-col justify-center" data-id="element-37">
                <h3 className="text-lg sm:text-2xl font-bold text-dark mb-1 sm:mb-2 leading-tight" data-id="element-38">
                  {bonus.title}
                </h3>
                <p className="text-sm sm:text-base text-dark/70 mb-3 sm:mb-4" data-id="element-39">
                  {bonus.desc}
                </p>

                <div className="flex items-center gap-2 sm:gap-3" data-id="element-40">
                  <span className="text-sm sm:text-base font-medium text-dark/40 line-through decoration-rose-deep/50 decoration-2" data-id="element-41">
                    {bonus.price}
                  </span>
                  <span className="bg-rose-deep text-white text-xs sm:text-sm font-bold px-2.5 sm:px-3 py-0.5 sm:py-1 rounded-full uppercase tracking-wider" data-id="element-42">
                    Gratis
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}